// Timeframe utilities for MTF support
// Allowed values in ascending order
export const TIMEFRAMES = ['M1','M5','M15','M30','H1','H4','D1','W1','MN1'];

// Map to minutes for comparison/multiples; months approximate as 43200 (30 days), weeks 10080
const TF_TO_MIN = {
  M1: 1,
  M5: 5,
  M15: 15,
  M30: 30,
  H1: 60,
  H4: 240,
  D1: 1440,
  W1: 10080,
  MN1: 43200,
};

export function tfToMinutes(tf) {
  return TF_TO_MIN[tf] ?? null;
}

export function isTfLower(tf, base) {
  const a = tfToMinutes(tf);
  const b = tfToMinutes(base);
  if (!a || !b) return false;
  return a < b;
}

export function isCleanMultiple(tf, base) {
  const a = tfToMinutes(tf);
  const b = tfToMinutes(base);
  if (!a || !b) return true;
  if (a < b) return false;
  return a % b === 0;
}

export function normalizeTf(tf) {
  if (!tf) return undefined;
  const up = String(tf).toUpperCase();
  return TIMEFRAMES.includes(up) ? up : undefined;
}
